module.exports = __webpack_public_path__ + "static/media/KegCycleStatus.64661430.png";